import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk-request-type-security.config-button.config-modal.title',
		defaultMessage: 'Restrict this request type',
		description: 'Title for the request type permission configuration modal.',
	},
	whoCanRaiseRequestsTabTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.who-can-raise-requests-tab-title',
		defaultMessage: 'Who can raise requests',
		description: 'Text to show in the tab title for the request type permissions configuration.',
	},
	whoCanViewIssuesTabTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.who-can-view-issues-tab-title',
		defaultMessage: 'Who can view issues',
		description: 'Text to show in the tab title for the request type issue security configuration.',
	},
	whoCanViewIssuesTabTitleIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.who-can-view-issues-tab-title-issue-term-refresh',
		defaultMessage: 'Who can view work items',
		description: 'Text to show in the tab title for the request type issue security configuration.',
	},
	cancelButton: {
		id: 'servicedesk-request-type-security.config-button.config-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the request type permission configuration modal.',
	},
	applyButton: {
		id: 'servicedesk-request-type-security.config-button.config-modal.apply-button',
		defaultMessage: 'Apply',
		description: 'Apply button for the request type permission configuration modal.',
	},
	reloadButton: {
		id: 'servicedesk-request-type-security.config-button.config-modal.reload-button',
		defaultMessage: 'Try again',
		description:
			'Reload button for the request type permission configuration modal when an error occurs.',
	},
	loadErrorTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.load-error-title',
		defaultMessage: 'We couldn’t load restrictions on this page',
		description:
			'Error title for when loading the permissions fails in the request type permission configuration modal.',
	},
	restrictionsApplySuccessTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-success-title',
		defaultMessage: 'Restrictions updated',
		description:
			'Message show to the user when they successfully updated the restrictions when saving the request type permissions.',
	},
	restrictionsApplySuccessDescription: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-success-description',
		defaultMessage: 'It may take a few moments for these changes to apply.',
		description:
			'Message show to the user when they successfully updated the restrictions when saving the request type permissions.',
	},
	restrictionsApplyFailureTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-failure-title',
		defaultMessage: 'We couldn’t update restrictions',
		description:
			'Title of the flag to show to the user when they failed to apply the restrictions when saving the request type permissions.',
	},
	restrictionsApplyFailureDescription: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-failure-description',
		defaultMessage: 'Select Apply to try again.',
		description:
			'Description of the flag to show to the user when they failed to apply the restrictions when saving the request type permissions.',
	},
	restrictionsApplyLimitedTitle: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-limited-title',
		defaultMessage: 'We’re unable to add users or groups',
		description:
			'Title of the flag to show to the user when they failed to apply the restrictions when saving the request type permissions because they added more users and groups than the limit.',
	},
	restrictionsApplyLimitedDescription: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-limited-description',
		defaultMessage:
			'No more than 50 users or groups can have access to this request type. Remove some users or groups, and try again.',
		description:
			'Description of the flag to show to the user when they failed to apply the restrictions when saving the request type permissions because they added more users and groups than the limit.',
	},
	restrictionsApplyMisconfigurationDescription: {
		id: 'servicedesk-request-type-security.config-button.config-modal.restrictions-apply-misconfiguration-description',
		defaultMessage: 'Resolve the misconfiguration and try again.',
		description:
			'Description of the flag to show to the user when they failed to apply the restrictions when saving the request type permissions because of a misconfiguration.',
	},
});
